type BlastAtmosphereProps = {
  variant?: 'hero' | 'section' | 'subtle'
  className?: string
}

export function BlastAtmosphere({
  variant = 'subtle',
  className = '',
}: BlastAtmosphereProps) {
  return (
    <div
      aria-hidden="true"
      className={`blast-atmosphere blast-atmosphere--${variant} ${className}`.trim()}
    >
      <span className="tnt-cube tnt-cube--one">
        <span>TNT</span>
      </span>
      <span className="tnt-cube tnt-cube--two">
        <span>TNT</span>
      </span>
      <span className="blast-spark blast-spark--one" />
      <span className="blast-spark blast-spark--two" />
      <span className="blast-spark blast-spark--three" />
      <span className="blast-debris blast-debris--one" />
      <span className="blast-debris blast-debris--two" />
      <span className="blast-trail" />
    </div>
  )
}
